<template>
  <ul class="batch-list">
    <li
      @click="batchClick(index)"
      v-for="(item, index) of batchArr"
      :key="index"
      class="batch-list-item"
    >
      <div class="font">
        <div class="font-row">
          <div class="line"></div>
          <span class="test-name">{{ item.batchName }}</span>
        </div>
        <span class="time" v-if="!isBeike"
          >{{ item.beginTime }}-{{ item.endTime }}</span
        >
      </div>
    </li>
  </ul>
</template>

<script>
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { computed } from "vue";
export default {
  name: "HomeBatchList",
  props: {
    // 批次列表
    batchArr: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  setup(props) {
    // 定义router
    const router = useRouter();
    const store = useStore();
    // 点击批次跳转到选择科目
    const batchClick = (index) => {
      const code = props.batchArr[index]?.batchCode;
      router.push(`/selectSubject/${code}`);
    };
    const isBeike = computed(() => {
      return store.getters.isBeike;
    });
    return {
      batchClick,
      isBeike,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "scss/color.scss";
.batch-list {
  padding: 24px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 55%;
  &-item {
    box-sizing: border-box;
    padding: 50px 24px;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 16px;
    box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.05);
    margin-top: 25px;
    .font {
      display: flex;
      flex-direction: column;
      &-row {
        display: flex;
        .line {
          width: 10px;
          height: 33px;
          background-color: var(--primary-color);
          border-radius: 4px;
          margin-right: 20px;
        }
        .test-name {
          font-size: 38px;
        }
      }
      .time {
        color: $color-gray;
        font-size: 28px;
        margin-top: 30px;
        margin-left: 33px;
      }
    }
  }
}
</style>
